'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = galleryQBUrl;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _QbUrlType = require('./QbUrlType');

var _qbBizIdMap = require('./qbBizIdMap');

var _qbBizIdMap2 = _interopRequireDefault(_qbBizIdMap);

var _galleryUrl = require('./galleryUrl');

var _galleryUrl2 = _interopRequireDefault(_galleryUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*
                                                                                                                                                                                                                              * @Author: edvardchen
                                                                                                                                                                                                                              * @Date:   2016-12-08 20:57:14
                                                                                                                                                                                                                              * @Last Modified by: jerryfwang
                                                                                                                                                                                                                              * @Last Modified time: 2020-09-23 12:08:07
                                                                                                                                                                                                                              */

/**
 * 图集QB地址
 * @param  {String} options.docId
 * @param  {String} options.tagId
 * @param  {String} options.ch
 * @return {String
 */
function galleryQBUrl(_ref) {
  var docId = _ref.docId,
      tagId = _ref.tagId,
      ch = _ref.ch,
      rest = _objectWithoutProperties(_ref, ['docId', 'tagId', 'ch']);

  var param = _queryString2.default.stringify({
    type: _QbUrlType.GALLERY,
    mttsummaryid: docId,
    b_f: ch,
    bizid: _qbBizIdMap2.default.coolread,
    contenturl: (0, _galleryUrl2.default)(_extends({
      docId: docId,
      tagId: tagId,
      ch: ch
    }, rest))
  });
  return 'qb://ext/read?cid=' + tagId + '&' + param;
}